import React from 'react';
import styled from 'styled-components';
import { isAndroid, isIOS, isMacOs, isMobile } from 'react-device-detect';
import { PrimaryButton } from '@docon/docon-ui-library';

const PROMOTION_URL = 'https://docon.co.in/appointment/promotion';
const APP_STORE_URL = 'https://apps.apple.com/us/app/docon/id1505731925';
const PLAY_STORE_URL =
  'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.docon.patientapp&referrer=utm_source%3Dpromotion_page';

const appStoreImg = '/images/appstore.svg';
const playStoreImg = '/images/playstore.svg';

function downloadApp(params: any) {
  const hasReturn = params?.hasReturn;
  const hasPromotion = params?.hasPromotion;
  let src;
  if (!isMobile && hasPromotion) {
    src = PROMOTION_URL;
  } else if (isIOS || isMacOs) {
    src = APP_STORE_URL;
  } else if (isAndroid) {
    src = PLAY_STORE_URL;
  }

  if (hasReturn) return src;

  if (src) window.open(src, '_blank');
}

const downloadAppPromotion = (params: any) => downloadApp({ hasPromotion: true, ...params });

function downloadImage() {
  if (isIOS || isMacOs) {
    return appStoreImg;
  } else if (isAndroid) {
    return playStoreImg;
  } else {
    return '';
  }
}

function DownloadApp(props: any) {

  return (
    <PrimaryButton
      size='small'
      title={'Download'}
      onClick={downloadApp}
      {...props}
    />
  );
}

export { downloadApp, downloadAppPromotion, downloadImage };
export default styled(DownloadApp)``;